// @ts-ignore
import Flatpickr from "react-flatpickr";

const DateInput = ({ id, name, addEstate, value }: any) => {
    return (
        <div className="mt-3">
            {addEstate &&
                <label htmlFor={id} className="form-label">{name}</label>
            }
            <Flatpickr
                className="form-control"
                value={value}
                options={{
                    weekNumbers: true,
                    altInput: true,
                    altFormat: "F j, Y",
                    dateFormat: "Y-m-d",
                }}
            />
        </div>
    );
};
export default DateInput;
